import {type ColorSchemeType, FlagColorScheme} from './FlagColorScheme';

export const getColorsFromScheme = (key: ColorSchemeType = 'neutral', isSubtle = false) => {
  const colorScheme = isSubtle ? FlagColorScheme.subtle : FlagColorScheme.primary;

  return colorScheme[key] ?? FlagColorScheme.primary.neutral;
};
